<mat-progress-bar mode="determinate" value="{{ progress }}"></mat-progress-bar>

<mat-card>
    <div class="kpi-config-top-area">
        <div class="kpi-config-title-area">Key Performance Indicators Setup</div>
        <!--        <div class="kpi-config-search-and-export-area">-->
        <!--            <div class="kpi-config-search-area">-->
        <!--                <search-dialog-->
        <!--                    (searchOutput)="searchRows($event)"-->
        <!--                    [searchId]="'kpi-config-mapping-search'"-->
        <!--                    [searchBoxHeight]="44"-->
        <!--                    [resetSearch]="false"-->
        <!--                >-->
        <!--                </search-dialog>-->
        <!--            </div>-->
        <!--            <div class="kpi-config-export-button-area">-->
        <!--                <button-->
        <!--                    mat-icon-button-->
        <!--                    (click)="exportToExcel()"-->
        <!--                    title="Download Excel"-->
        <!--                    class="kpi-config-export-button"-->
        <!--                >-->
        <!--                    <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>-->
        <!--                </button>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
    <div class="kpi-config-tabs-and-button-area">
        <mat-tab-group
            animationDuration="0ms"
            [selectedIndex]="tab"
            (selectedIndexChange)="handleTabChange($event)"
            dynamicHeight=""
        >
            <mat-tab *ngFor="let t of tabs" class="kpi-config-mat-tab">
                <ng-template mat-tab-label>
                    <div class="kpi-config-mat-tab-label-area">
                        <div class="kpi-config-mat-tab-value-area">
                            {{ t.index + 1 }}
                        </div>
                        <div class="kpi-config-mat-tab-description-container">
                            <span class="kpi-config-mat-tab-value-string-top"
                                >STEP {{ t.index + 1 }}</span
                            >
                            <br />
                            <span class="kpi-config-mat-tab-value-string-bottom">{{
                                t.label
                            }}</span>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <div class="kpi-config-btn-container">
            <div class="kpi-config-btn-group">
                <span *ngIf="hasInvalidData">Please fix errors on Step 2 before Proceeding. </span>
                <mat-button-toggle-group
                    name="fontStyle"
                    aria-label="Font Style"
                    *ngIf="!dataSaved"
                >
                    <mat-button-toggle value="bold" (click)="back()" [disabled]="backDisabled()"
                        >BACK</mat-button-toggle
                    >
                    <mat-button-toggle
                        value="italic"
                        (click)="next()"
                        [disabled]="!canSave() || isSaving"
                    >
                        <span *ngIf="tab !== 2">NEXT</span>
                        <span *ngIf="tab === 2" (click)="save()">{{
                            isSaving ? 'SAVING...' : 'SAVE'
                        }}</span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!dataSaved; else elseBlock">
        <div class="kpi-config-tab-data-container">
            <app-kpi-config-one
                [data]="data"
                [loading]="loading"
                (updatedKPIfData)="updateKPIfData($event)"
                *ngIf="tab === 0"
            ></app-kpi-config-one>

            <app-kpi-config-three [data]="data" [loading]="loading" *ngIf="tab === 1">
            </app-kpi-config-three>

            <app-kpi-config-four [data]="data" [loading]="loading" *ngIf="tab === 2">
            </app-kpi-config-four>
        </div>
    </ng-container>
    <ng-template #elseBlock>
        <div class="kpi-config-message-area" style="">Your KPI Configs have been saved.</div>
    </ng-template>
</mat-card>
